const defaultProps = {
  _statNumber: {
    fontSize: '3xl',
    fontWeight: 700,
    my: 2,
  },
  _statHelpText: {
    opacity: 0.7,
    flexDirection: 'row',
    alignItems: 'center',
  },
  _statGroup: {
    flexWrap: 'wrap',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
};

export default {
  defaultProps,
};
